module.exports = __webpack_public_path__ + "assets/img/9eea-ng.svg";